export { default } from "bullitttime-embermodelsevent/models/class";
